import React from 'react';
import { motion } from 'framer-motion';
import { PlaneIcon, HotelIcon, UtensilsIcon, CoffeeIcon, ClipboardListIcon, SparklesIcon, BusIcon, HeartHandshakeIcon, TargetIcon, LeafIcon } from 'lucide-react';
const inclusions = [['Round-trip airfare', PlaneIcon], ['Two nights accommodation', HotelIcon], ['Two hosted dinners', UtensilsIcon], ['Breakfasts & breaks', CoffeeIcon], ['Strategic planning workshop', ClipboardListIcon], ['Interactive mapping session', TargetIcon], ['Luxury spa experience', SparklesIcon], ['Airport transfers', BusIcon]];
export function RetreatHighlights() {
  return <section className="bg-[#f6f2e8] px-5 py-24 sm:px-8" id="purpose" data-id="element-274" data-mp="1qfbu1s1u1sd7">
      <div className="mx-auto max-w-7xl" data-id="element-275" data-mp="1lfpe3aumdy0p">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-276" data-mp="1leo0ozq4szft">
          <div data-id="element-277" data-mp="31tfspbjd84ol">
            <p className="text-xs font-800 uppercase tracking-[0.2em] text-[#7b937a]" data-id="element-278" data-mp="31swf270r02gd">Why we’re gathering</p>
            <h2 className="mt-4 max-w-lg font-display text-4xl font-500 leading-tight text-[#263b35] sm:text-5xl" data-id="element-279" data-mp="2wu2yg5q5zvbz">Space to think clearly. Time to move forward together.</h2>
            <p className="mt-6 max-w-xl text-lg leading-8 text-[#52635d]" data-id="element-280" data-mp="b1y1hdwn3kyc">The Board Retreat is an intentional pause from the day-to-day: a place to celebrate what we’ve built and shape what comes next.</p>
            <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-281" data-mp="k3p6shn9ppro">
              {[['Strengthen relationships', HeartHandshakeIcon], ['Reflect on our accomplishments', SparklesIcon], ['Shape our strategic direction', TargetIcon], ['Invest in wellness & connection', LeafIcon]].map(([label, Icon]) => {
              const FeatureIcon = Icon as typeof HeartHandshakeIcon;
              return <div key={label as string} className="flex items-center gap-3 rounded-2xl border border-[#dbe2d2] bg-white/65 p-4 text-sm font-700 text-[#31483f]" data-id="element-282" data-mp="15l70dt9t32j"><FeatureIcon className="h-5 w-5 text-[#b68c37]" data-id="element-283" data-mp="30q8fdn0uzkdw" />{label as string}</div>;
            })}
            </div>
          </div>
          <div className="rounded-[2rem] bg-[#d9e6e5] p-5 sm:p-7" data-id="element-284" data-mp="byece6ics07j">
            <div className="grid gap-3 sm:grid-cols-2" data-id="element-285" data-mp="70325uo5bnos">
              {inclusions.map(([label, Icon], index) => {
              const InclusionIcon = Icon as typeof PlaneIcon;
              return <motion.div key={label as string} initial={{
                opacity: 0,
                y: 12
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                delay: index * 0.05
              }} className="rounded-2xl bg-white/80 p-5 shadow-sm backdrop-blur" data-id="element-286" data-mp="gpwgh3foagwq" data-mpi={index}>
                    <InclusionIcon className="h-5 w-5 text-[#b68c37]" data-id="element-287" data-mp="3k8fw96h5zuan" />
                    <p className="mt-5 font-display text-lg font-600 text-[#2b4239]" data-id="element-288" data-mp="221ip8mt5mcs">{label as string}</p>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}